import {addGlobals} from '../modules/addGlobals';
import HTMLPlayer from '../modules/HTMLPlayer';
import AdvPlayer from '../modules/AdvPlayer';
import {swfobject} from '../modules/swfobject';

class Player {
	constructor(player){
		this.player = player;
		this.data = JSON.parse(this.player.getAttribute('data-param'));
		this._getData();
	}

	_getHtml(data){

		var LQ = data.files.low ? data.files.low.path.replace(/\.mp4$/, '') : false;
		var HQ = data.files.high ? data.files.high.path.replace(/\.mp4$/, '') : false;
		var quality = '"LQ": "' + LQ + '"' + (HQ ? (', "HQ": "' + HQ + '"') : '');

		return  '<div data-js="html-player" data-quality=\'{'+ quality +'}\' class="htmlPlayer">'+
			'<video data-js="video" preload="metadata" class="htmlPlayer_video" controls="controls" poster="'+ data.poster +'" webkit-playsinline>'+
			'<source src="'+ data.files.low.path +'" type="video/mp4" />'+
			'<a class="htmlPlayer_altVideo" href="'+ data.files.low.path +'"  style="background-image:url('+ data.poster +')">'+
			'<img class="htmlPlayer_altVideoPoster" src="'+ data.poster +'" alt="" />'+
			'<img class="htmlPlayer_altVideoBtn" src="http://video.kinoafisha.info/i/player/play-btn.png" alt="" />'+
			'</a>'+
			'</video>'+
			'<div data-js="toggle" class="htmlPlayer_toggle">'+
			'<img class="htmlPlayer_bigPauseBtn" src="http://video.kinoafisha.info/i/player/pause-btn.png" alt="" />'+
			'</div>'+
			'<div data-js="footer" class="htmlPlayer_footer">'+
			'<div data-js="controls" class="htmlPlayer_controls">'+
			'<div class="htmlPlayer_controlsCell htmlPlayer_controlsCell-shrink">'+
			'<div class="htmlPlayer_playback htmlPlayer_controlsBtn">'+
			'<img data-js="play"  class="htmlPlayer_playBtn" src="http://video.kinoafisha.info/i/player/play.png" alt="" />'+
			'<img data-js="pause"  class="htmlPlayer_pauseBtn" src="http://video.kinoafisha.info/i/player/pause.png" alt="" />'+
			'</div>'+
			'<div class="htmlPlayer_time">'+
			'<span data-js="timeCur" class="htmlPlayer_timeCur"></span>'+
			'<span class="htmlPlayer_timeSep">/</span>'+
			'<span data-js="timeDur" class="htmlPlayer_timeDur"></span>'+
			'</div>'+
			'</div>'+

			'<div class="htmlPlayer_controlsCell">'+
			'<div data-js="rewind" data-meter = \'{}\'  class="playerMeter  htmlPlayer_controlsBtn">'+
			'<div class="playerMeter-strip"></div>'+
			'<div data-js="buffered" class="playerMeter-buffered"></div>'+
			'<div data-js="progress" class="playerMeter-progress"></div>'+
			'<div data-js="slider" class="playerMeter-slider"></div>'+
			'</div>'+
			'</div>'+

			'<div class="htmlPlayer_controlsCell  htmlPlayer_controlsCell-shrink">'+
			'<span data-js="quality" class="htmlPlayer_qualityBtn htmlPlayer_controlsBtn">hq</span>'+

			'<div data-js="mute" class="htmlPlayer_mute htmlPlayer_controlsBtn">'+
			'<img  data-js="mute-on" data-js="mute-on"  class="htmlPlayer_muteOn" src="http://video.kinoafisha.info/i/player/mute-on.png" alt="" />'+
			'<img  data-js="mute-off" data-js="mute-off"  class="htmlPlayer_muteOff" src="http://video.kinoafisha.info/i/player/mute-off.png" alt="" />'+
			'</div>'+

			'<div data-js="volume" data-meter = \'{"value": 1}\'  class="playerMeter playerMeter_volume htmlPlayer_controlsBtn">'+
			'<div class="playerMeter-strip"></div>'+
			'<div data-js="progress" class="playerMeter-progress"></div>'+
			'<div data-js="slider" class="playerMeter-slider"></div>'+
			'</div>'+

			'<div data-js="fullscreen" class="htmlPlayer_fullscreen htmlPlayer_controlsBtn"> '+
			'<img data-js="fullscreen-request"  class="htmlPlayer_fullscreenRequest" src="http://video.kinoafisha.info/i/player/fullscreen-request.png" alt="" />'+
			'<img data-js="fullscreen-exit"  class="htmlPlayer_fullscreenExit" src="http://video.kinoafisha.info/i/player/fullscreen-exit.png" alt="" />'+
			'</div>'+

			'<div data-js="share-btn" class="htmlPlayer_shareBtn htmlPlayer_controlsBtn">&lt;/&gt;</div>'+

			'</div>'+
			'</div>'+
			'<div data-js="share" class="htmlPlayer_share">'+
			'<div class="htmlPlayer_shareItem">'+
			'<div class="htmlPlayer_shareCell htmlPlayer_shareCell-title">'+
			'Ссылка на ролик'+
			'</div>'+
			'<div class="htmlPlayer_shareCell">'+
			'<input readonly class="htmlPlayer_shareField htmlPlayer_shareField-insert" type="text" value="'+ data.trailer_url +'" />'+
			'</div>'+
			'<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">'+
			'&nbsp;'+
			'</div>'+
			'</div>'+
			'<div class="htmlPlayer_shareItem">'+
			'<div class="htmlPlayer_shareCell htmlPlayer_shareCell-title">'+
			'Код для вставки'+
			'</div>'+
			'<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">'+
			'<span class="htmlPlayer_shareNote">ширина</span>'+
			'<input data-js="embed-width" class="htmlPlayer_shareField htmlPlayer_shareField-size" type="text" value="640" />'+
			'<span class="htmlPlayer_shareNote">высота</span>'+
			'<input data-js="embed-height" class="htmlPlayer_shareField htmlPlayer_shareField-size" type="text" value="360" />'+
			'</div>'+
			'<div class="htmlPlayer_shareCell">'+
			'<input data-js="embed" readonly class="htmlPlayer_shareField htmlPlayer_shareField-insert" type="text" value=\''+ data.embed_url +'\' />'+
			'</div>'+
			'<div class="htmlPlayer_shareCell htmlPlayer_shareCell-shrink">'+
			'&nbsp;'+
			'</div>'+
			'</div>'+
			'</div>'+
			'</div>'+
			'<img  class="htmlPlayer_logo" src="http://video.kinoafisha.info/i/player/logo.png" alt="" />'+
			'<div data-js="poster" class="htmlPlayer_poster" style="background-image:url('+ data.poster +')">'+
			'<div class="htmlPlayer_posterInfo">'+
			'<span class="htmlPlayer_posterCat">'+ data.title +'</span>'+
			'<span class="htmlPlayer_posterName">'+ data.movie_name +'</span>'+
			'</div>'+
			'<img  class="htmlPlayer_posterBtn" src="http://video.kinoafisha.info/i/player/play-btn.png" alt="" />'+
			'</div>'+
			'<div class="htmlPlayer_preloader"></div>'+
			'</div>'+
			'<div data-js="adv-player" data-param="' +data.advVideo+'" class="advPlayer">'+
			'<video data-js="adv-video" class="advPlayer_video"></video>'+
			'<a data-js="adv-clicking-btn" class="advPlayer_link" target="_blank" href="'+data.advLink+'"></a>'+
			'<div class="advPlayer_controls">'+
			'<div class="advPlayer_controlsCell">'+
			'<span class="advPlayer_param">Реклама.</span> <span data-js="adv-left" class="advPlayer_param">&nbsp;</span>'+
			'</div>'+
			'<div class="advPlayer_controlsCell">'+
			'<a data-js="adv-skip-btn" class="advPlayer_param" href="#">&nbsp;</a>'+
			'</div>'+
			'</div>'+
			'<div class="advPlayer_before">'+
			'<div class="advPlayer_beforeContent">'+
			'<div class="advPlayer_beforeContentItem">Реклама</div>'+
			'</div>'+
			'</div>'+
			'<div class="advPlayer_preloader"></div>'+
			'</div>';
	}

	_getData(){
		var self = this,
            path = window.location.hostname.indexOf('kinoafishaspb.ru') === -1 ? 'kinoafisha.info' : 'kinoafishaspb.ru';

		GLOBALS.scriptRequest('http://api.'+ path +'/player/info/' + this.data.trailer_id + '/', function(data){self._onSuccess.call(self, data)}, function(){self._onError.call(self)});
	}

	_onSuccess(dataApi){
		this.player.innerHTML = this._getHtml(this._checkAdv(dataApi));
		this._initHTMLPlayer();
	}

	_onError(){

	}

	_checkAdv(dataApi){
		//var num = Math.floor(Math.random() * (4 - 1 + 1)) + 1;
		//var num = 6;

		//dataApi.advVideo = 'http://video.kinoafisha.info/branding/binomo/binomo-' + num;
		//dataApi.advLink = 'http://t.trafdsp.com/in/kinoafisha'+ num +'/';
		dataApi.advVideo = 'http://video.kinoafisha.info/branding/kinoafisha/kinoafisha-youtube';
		dataApi.advLink = 'https://www.youtube.com/channel/UCNuQyDGBj28VwMRhCy_hTOw';

		return dataApi;
	}

	_initFlashPlayer(){
		var self = this;

		this.player.innerHTML = '<div id="'+ 'flash-' + this.data.trailer_id +'"></div>';
		this.player.className += ' player-flash';

		swfobject.embedSWF('http://v0.kinoafisha.org/swf/ka_player/v10_player.swf', 'flash-' + this.data.trailer_id, "100%", "100%", "9.0.0", "http://v0.kinoafisha.org/swf/expressInstall.swf", {
				"trailer_id": this.data.trailer_id,
				"host": this.data.host,
				"bottom_vote": this.data.bottom_vote,
				"autostart":"false"
			},{
				"quality": "high",
				"wmode": "opaque",
				"allowFullScreen": "true",
				"allowScriptAccess": "always"
			},
			null,
			function(e){
				//if(!e.success) self._initHTMLPlayer.call(self);
			}
		)
	}

	_initHTMLPlayer(){
		var htmlPlayerWrapper = this.player.querySelector('[data-js="html-player"]');
		var advPlayerWrapper = this.player.querySelector('[data-js="adv-player"]');
		var advPlayer = this.data.isHideAdv ? false : new AdvPlayer(advPlayerWrapper);
		//var advPlayer = false;

		this.htmlPlayer = new HTMLPlayer(htmlPlayerWrapper, advPlayer, this.data);

		if(!this.htmlPlayer.isCanPlay) this._initFlashPlayer();
	}

    del(){
        this.htmlPlayer.video.onloadedmetadata = function(){}
        this.htmlPlayer.video.innerHTML = '';
        this.htmlPlayer.video.setAttribute('src', '');
        delete this.htmlPlayer;
    }
}

//window.Player = Player;
export {Player}

















